import { cx } from '@linaria/core';
import { cssToolbarButtonLike } from './cssToolbarButtonLike';
export const ToolbarSwitch = ({
  className,
  name,
  value,
  title,
  hint,
  selected,
  disabled,
  children
}: {
  className?: string;
  name: string;
  value: string | number;
  title?: string;
  hint?: string;
  selected: boolean;
  disabled?: unknown;
  children: any;
}) => <label title={title} data-hint={hint} disabled={!!disabled} className={cx(cssToolbarButtonLike, className, selected && 'active')}>
    <input type="radio" hidden name={name} value={value} checked={selected} />
    {children}
  </label>;